module.exports = __webpack_public_path__ + "img/not-found.a638876c.png";